<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1>檔案上傳中</h1>
      <img :src="require('../../assets/images/upload.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// src/components/layout/uploading.vue